const CONFIG = {
  pending: { label: "En attente", color: "bg-gray-100 text-gray-700" },
  deposit_paid: { label: "Acompte payé", color: "bg-amber-100 text-amber-800" },
  confirmed: { label: "Confirmée", color: "bg-blue-100 text-blue-700" },
  handover: { label: "Remise en cours", color: "bg-purple-100 text-purple-700" },
  in_progress: { label: "Location en cours", color: "bg-[#dcfce7] text-[#0e7a3f]" },
  returned: { label: "Véhicule restitué", color: "bg-cyan-100 text-cyan-700" },
  completed: { label: "Terminée", color: "bg-emerald-100 text-emerald-800" },
  cancelled: { label: "Annulée", color: "bg-red-100 text-red-700" },
};

export const STATUS_LABELS = Object.fromEntries(Object.entries(CONFIG).map(([k, v]) => [k, v.label]));
export const STATUS_ORDER = ["pending", "deposit_paid", "confirmed", "handover", "in_progress", "returned", "completed"];

export default function StatusBadge({ status }) {
  const c = CONFIG[status] || CONFIG.pending;
  return (
    <span className={`text-xs px-2.5 py-1 rounded-full font-bold whitespace-nowrap ${c.color}`}>{c.label}</span>
  );
}
